import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Componente SEO dinámico mediante React Helmet Async para VeezDocs
 */
export default function HelmetSEO({ activeTab }) {
  const metaConfig = {
    desarrolladores: {
      title: "Documentación para Desarrolladores | API REST & Webhooks VeezDelivery",
      description: "Guía técnica e integración de la API REST de VeezDelivery, especificación OpenAPI 3.1.0, Webhooks e integración con WooCommerce, Shopify y Odoo.",
      canonical: "https://docs.veez.cl/#desarrolladores"
    },
    clientes: {
      title: "Guía para Clientes & Comercios | Envíos Express & Devolución Inteligente VeezDelivery",
      description: "Conoce cómo funcionan los envíos express, el sistema de Devoluciones Inteligentes con 50% de descuento, seguimiento GPS en tiempo real y código PIN de seguridad.",
      canonical: "https://docs.veez.cl/#clientes"
    },
    repartidores: {
      title: "Guía para Repartidores & Conductores | Colectas en Ruta & Ganancias Extra VeezDelivery",
      description: "Aprende cómo aceptar colectas en ruta mientras realizas tus entregas, ganar bonos adicionales por desvío, validación por código PIN de entrega y reglas de la flota.",
      canonical: "https://docs.veez.cl/#repartidores"
    }
  };

  const current = metaConfig[activeTab] || metaConfig.desarrolladores;

  return (
    <Helmet>
      <html lang="es" />
      <title>{current.title}</title>
      <meta name="description" content={current.description} />
      <link rel="canonical" href={current.canonical} />

      {/* Open Graph Tags */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="VeezDocs" />
      <meta property="og:title" content={current.title} />
      <meta property="og:description" content={current.description} />
      <meta property="og:url" content={current.canonical} />
      <meta property="og:image" content="https://docs.veez.cl/assets/logo.png" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={current.title} />
      <meta name="twitter:description" content={current.description} />
      <meta name="twitter:image" content="https://docs.veez.cl/assets/logo.png" />
    </Helmet>
  );
}
